var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSyncDetails(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 112,
    viewBox: "0 0 119 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.9844 42.7752C71.6144 42.7752 63.0944 42.4352 55.1244 40.2152C47.3044 38.0452 40.1244 33.8352 33.7244 28.9652C29.5344 25.7952 25.7244 23.2752 20.2844 23.6552C14.9579 23.9468 9.86681 25.9454 5.76441 29.3552C-1.15559 35.3552 -0.11559 46.5852 2.65441 54.4752C6.81441 66.3552 19.4744 74.5852 30.2344 79.9652C42.6644 86.1752 56.3244 89.7752 70.0144 91.8552C82.0144 93.6752 97.4344 95.0052 107.834 87.1652C117.384 79.9652 120.004 63.5252 117.664 52.4252C117.097 49.1431 115.351 46.181 112.754 44.0952C106.044 39.1952 96.0344 42.4652 88.4944 42.6352C85.6944 42.6952 82.8444 42.7652 79.9844 42.7752Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.503 111.305C79.7773 111.305 96.213 110.279 96.213 109.015C96.213 107.75 79.7773 106.725 59.503 106.725C39.2286 106.725 22.793 107.75 22.793 109.015C22.793 110.279 39.2286 111.305 59.503 111.305Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0137 30.5547V34.8647",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8633 32.7148H99.1633",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.793 66.7754V71.0754",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6348 68.9258H26.9448",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7637 12.6348V16.9348",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6055 14.7852H20.9155",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6245 2.65531C66.1658 2.65531 66.6045 2.21655 66.6045 1.67531C66.6045 1.13407 66.1658 0.695312 65.6245 0.695312C65.0833 0.695312 64.6445 1.13407 64.6445 1.67531C64.6445 2.21655 65.0833 2.65531 65.6245 2.65531Z",
    fill: "#CFCFCF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2847 98.2549C63.8259 98.2549 64.2647 97.8162 64.2647 97.2749C64.2647 96.7337 63.8259 96.2949 63.2847 96.2949C62.7434 96.2949 62.3047 96.7337 62.3047 97.2749C62.3047 97.8162 62.7434 98.2549 63.2847 98.2549Z",
    fill: "#CFCFCF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3299 7.33116L27.2968 13.2551C25.9949 13.3904 25.0491 14.5554 25.1843 15.8573L32.9845 90.9533C33.1197 92.2552 34.2847 93.201 35.5866 93.0658L92.6198 87.1418C93.9217 87.0066 94.8675 85.8415 94.7323 84.5396L86.9321 9.44363C86.7969 8.14172 85.6318 7.19593 84.3299 7.33116Z",
    fill: "#D2D2D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8753 10.7993L30.4022 16.1458C29.1003 16.281 28.1545 17.446 28.2898 18.7479L35.344 86.6626C35.4792 87.9645 36.6443 88.9103 37.9462 88.775L89.4193 83.4286C90.7212 83.2933 91.667 82.1283 91.5317 80.8264L84.4775 12.9118C84.3423 11.6099 83.1772 10.6641 81.8753 10.7993Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.395 31.6992C65.9866 31.6992 66.4489 32.21 66.39 32.7987L63.89 57.7987C63.8389 58.3099 63.4088 58.6992 62.895 58.6992H60.605C60.0912 58.6992 59.6611 58.3099 59.61 57.7987L57.11 32.7987C57.0511 32.21 57.5134 31.6992 58.105 31.6992L65.395 31.6992Z",
    stroke: "#BABABA",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9999 62C63.5522 62 64 62.4478 63.9999 63.0001L63.9998 66.0001C63.9997 66.5523 63.552 67 62.9998 67H60.0002C59.4478 67 59.0001 66.5522 59.0002 65.9998L59.0007 62.9998C59.0008 62.4476 59.4485 62 60.0007 62H62.9999Z",
    stroke: "#BABABA",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSyncDetails);
export default __webpack_public_path__ + "static/media/no_sync_details.84c40622afd7dd50d7923835b27cff38.svg";
export { ForwardRef as ReactComponent };